angular.module('autoremind.directives')
    .directive('showFocus', ['$timeout', function ($timeout) {
        return function (scope, element, attrs) {
            scope.$watch(attrs.showFocus, function (newValue) {
                $timeout(function () {
                    newValue && element.focus();
                });
            }, true);
        };
    }]);
//# sourceMappingURL=show-focus.directive.js.map